/**
 * Created by tek on 11/16/2015 AD.
 */
$(document).ready(function() {

    window.ModuleList = {
        overflowScroll: (param=[".scroll"]) => { return Helper.setOverflowScroll(param); },
        multiselect: (param=[".multiselect"]) => { return Multiselect.getInstance().load(param); }
    };

    $.fn.modal.Constructor.prototype.enforceFocus = function() {};

    $(document).on('keypress',".numberonly",function (evt)
    {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode!=37 && charCode!=39 && charCode!=8)
            return false;
        return true;
    });
    $(document).on('keypress',".numberonlydot",function (evt)
    {
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode!=46 && charCode!=37 && charCode!=39 && charCode!=8)
            return false;
        return true;
    });
    $(document).on('keypress',".numberonlydotlob",function (evt)
    {
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode!=46 && charCode!=45 && charCode!=37 && charCode!=39 && charCode!=8)
            return false;
        return true;
    });
});

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

function digit(v)
{
    var base = (typeof display_limit_digit!=='undefined' && display_limit_digit!=null)?Math.pow(10,display_limit_digit):100;
    return Math.round(v * base) / base;
}